import {Controller} from "@hotwired/stimulus"
import {Modal} from "bootstrap";

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  connect() {
    let backdrop = document.querySelector(".modal-backdrop")
    if (backdrop) {
      backdrop.remove()
    }

    this.modal = new Modal(this.element)
    this.modal.show()

    // $(this.element).on('hidden.bs.modal', function (e) {
    //   Turbo.visit(window.location, {action: "advance"})
    // });

  }

  disconnect() {
    this.modal.hide()
    this.element.remove()
  }

  submitEnd(e) {
    if (e.detail.success) {
      this.closeModal()
      if (e.detail.fetchResponse.response.redirected) {
        Turbo.visit(e.detail.fetchResponse.response.url)
      }
    }
  }

  closeModal() {
    this.modal.hide()
    let backdrop_loading = document.querySelector(".modal-backdrop-loading")
    if (backdrop_loading) {
      backdrop_loading.hidden = true
    }

  }

}
